import * as React from "react";
import CreateService from "../../../service/create";
import ReadService from "../../../service/read";
import SecondLayer from "../../container/second_layer";
import ProjectListPane from "./project_list";
import {ProjectsService} from "../../../service/v1/projects";
import PopDetail from "../../popdetail";
import AddNewProjectPane from "./add_new_project_pane";
import MonitoringEvaluationListPane from "./monitoring_evaluation_list";

export default class ProjectInfoPane extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            station: {},
            info: {
                localities: [],
                funders: [],
            },
            activeTab: 'overview',
            isLoading: false,
            isRefreshing: false,
            isStateChanging: false,
            buttonsVisible: false,
            userClickedApprove: false
        }
        this.fetchProjectInfo = this.fetchProjectInfo.bind(this)
        this.setActiveTab = this.setActiveTab.bind(this)
        this.handleStateChange = this.handleStateChange.bind(this)
    }

    componentDidMount() {
        this.setState({ isLoading: true, buttonsVisible: false });
        this.fetchProjectInfo();
        
        // Detect page refresh/reload
        window.addEventListener('beforeunload', this.handlePageRefresh);
        
        // Enable buttons after initial load is complete
        setTimeout(() => {
            this.setState({ buttonsVisible: true, isLoading: false });
            
            // Check if project is already approved on initial load
            if (this.state.info.status && 
                (this.state.info.status.toLowerCase() === 'approved' || this.state.info.status === 'Approved')) {
                this.setState({ userClickedApprove: true });
                console.log('Project already approved on load, hiding buttons');
                
                // Update project.action to ensure tasks are visible for backend-approved projects
                if (this.props.project.action !== 'approved' && this.props.project.action !== 'Approved') {
                    this.props.project.action = 'approved';
                    console.log('Updated project.action to approved for backend-approved project');
                    
                    // Trigger task loading for backend-approved projects
                    const event = new CustomEvent('projectApproved', {
                        detail: { project: this.props.project }
                    });
                    window.dispatchEvent(event);
                    console.log('Dispatched projectApproved event for backend-approved project on load');
                }
            }
        }, 1000);
    }

    componentWillUnmount() {
        window.removeEventListener('beforeunload', this.handlePageRefresh);
    }

    handlePageRefresh = () => {
        this.setState({ buttonsVisible: false, isRefreshing: true });
    }

    componentDidUpdate(prevProps, prevState) {
        // Detect state changes and hide buttons temporarily
        if (prevState.info.status !== this.state.info.status) {
            this.handleStateChange();
            
            // If status becomes approved, mark as clicked to hide buttons permanently
            if (this.state.info.status && 
                (this.state.info.status.toLowerCase() === 'approved' || this.state.info.status === 'Approved')) {
                this.setState({ userClickedApprove: true });
                console.log('Status is approved, hiding buttons permanently');
                
                // Update project.action to ensure tasks are visible
                if (this.props.project.action !== 'approved' && this.props.project.action !== 'Approved') {
                    this.props.project.action = 'approved';
                    console.log('Updated project.action to approved for task visibility');
                    
                    // Trigger task loading for backend-approved projects
                    const event = new CustomEvent('projectApproved', {
                        detail: { project: this.props.project }
                    });
                    window.dispatchEvent(event);
                    console.log('Dispatched projectApproved event for backend-approved project');
                }
            }
        }
    }

    fetchProjectInfo() {
        try {
            this.setState({ isRefreshing: true, buttonsVisible: false });
            ProjectsService.fetchProjectInfo(this.props.project.id).then(d => {
                try {
                    console.log('Project info response:', d.data);
                    this.setState({
                        info: d.data.results,
                        isRefreshing: false
                    });
                    console.log('Updated project info status:', d.data.results.status);
                    
                    // Re-enable buttons after data is loaded
                    setTimeout(() => {
                        this.setState({ buttonsVisible: true });
                    }, 500);
                } catch (e) {
                    console.log(e);
                    this.setState({ isRefreshing: false, buttonsVisible: true });
                }
            }).catch(error => {
                console.error('Error fetching project info:', error);
                this.setState({ isRefreshing: false, buttonsVisible: true });
            });
        } catch (e) {
            console.log(e);
            this.setState({ isRefreshing: false, buttonsVisible: true });
        }
    }

    handleStateChange() {
        this.setState({ isStateChanging: true, buttonsVisible: false });
        
        // Re-enable buttons after state change is complete
        setTimeout(() => {
            this.setState({ isStateChanging: false, buttonsVisible: true });
        }, 1500);
    }

    setActiveTab(tabName) {
        this.setState({ activeTab: tabName });
    }

    approveProject(action) {
        try {
            this.setState({ isStateChanging: true, buttonsVisible: false, userClickedApprove: true });
            ProjectsService.remarkProject({
                action: action,
                remarks: 'Project was ' + action,
                status_code: action,
                task_id: '',
                screen_code: '',
            }, this.props.project.id).then(r => {
                console.log('Approval response:', r);
                
                // Update the project action in props to reflect the new status
                this.props.project.action = action;
                console.log('Updated project action:', this.props.project.action);
                
                // Trigger task loading when project is approved
                if (action === 'approved') {
                    console.log('Project approved, triggering task retrieval...');
                    // Dispatch custom event for parent to listen
                    const event = new CustomEvent('projectApproved', {
                        detail: { project: this.props.project }
                    });
                    window.dispatchEvent(event);
                }
                
                // Refresh project info to get updated status
                this.fetchProjectInfo();
                
                // Close the second layer and refresh the project list
                SecondLayer.dismiss()
                if (this.props.project.project_type_info.name.toLowerCase().includes("monitoring")){
                    MonitoringEvaluationListPane.loadData()
                } else {
                    ProjectListPane.loadData()
                }
            }).catch(error => {
                console.error('Approval failed:', error);
                alert('Failed to approve project. Please try again.');
                this.setState({ isStateChanging: false, buttonsVisible: true, userClickedApprove: false });
            })
        } catch (e) {
            console.log(e)
            alert('Failed to approve project. Please try again.');
            this.setState({ isStateChanging: false, buttonsVisible: true, userClickedApprove: false });
        }
    }

    rejectProject(action, reason) {
        try {
            this.setState({ isStateChanging: true, buttonsVisible: false, userClickedApprove: true });
            ProjectsService.remarkProject({
                action: action,
                remarks: 'Project was ' + action + ' : ' + reason,
                status_code: action,
                task_id: '',
                screen_code: '',
            }, this.props.project.id).then(r => {
                // Update the project action in props to reflect the new status
                this.props.project.action = action;
                
                // Refresh project info to get updated status
                this.fetchProjectInfo();
                
                PopDetail.dismiss()
                ProjectListPane.loadData()
            }).catch(error => {
                console.error('Rejection failed:', error);
                alert('Failed to reject project. Please try again.');
                this.setState({ isStateChanging: false, buttonsVisible: true, userClickedApprove: false });
            });
        } catch (e) {
            console.log(e)
            alert('Failed to reject project. Please try again.');
            this.setState({ isStateChanging: false, buttonsVisible: true, userClickedApprove: false });
        }
    }

    render() {
        console.log("GGGG")
        console.log(sessionStorage.getItem('user_groups'))
        
        // Alternative modern styling with different visual approach
        const fontFamily = 'Poppins, Inter, Open Sans, Helvetica, Arial, sans-serif';
        const primaryColor = '#2563eb';
        const secondaryColor = '#7c3aed';
        const accentColor = '#f59e0b';
        const successColor = '#10b981';
        const dangerColor = '#ef4444';
        const lightGray = '#f1f5f9';
        const darkGray = '#64748b';
        const white = '#ffffff';
        
        const container = {
            width: '100%',
            minHeight: '100vh',
            background: `linear-gradient(135deg, ${lightGray} 0%, #e2e8f0 100%)`,
            fontFamily,
            padding: '0',
            margin: '0',
            overflow: 'hidden',
            boxSizing: 'border-box',
            display: 'flex',
            flexDirection: 'column'
        };
        
        const header = {
            background: white,
            padding: '16px 20px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            fontSize: 18,
            fontWeight: 700,
            fontFamily,
            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
            marginBottom: '16px',
            borderBottom: `3px solid ${primaryColor}`,
            width: '100%',
            boxSizing: 'border-box',
            flexShrink: 0
        };
        
        const headerTitle = {
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            fontSize: '16px',
            fontWeight: 700,
            color: primaryColor,
            flex: 1,
            minWidth: 0,
            '@media (max-width: 768px)': {
                fontSize: '14px',
                gap: '6px'
            }
        };
        
        const headerIcon = {
            width: '36px',
            height: '36px',
            background: `linear-gradient(135deg, ${primaryColor} 0%, ${secondaryColor} 100%)`,
            borderRadius: '8px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: white,
            fontSize: '14px',
            boxShadow: '0 4px 12px rgba(37, 99, 235, 0.3)',
            flexShrink: 0
        };
        
        const actionButtons = {
            display: 'flex',
            gap: '8px',
            marginBottom: '16px',
            padding: '0 16px',
            justifyContent: 'center',
            width: '100%',
            boxSizing: 'border-box',
            flexWrap: 'wrap',
            flexShrink: 0
        };
        
        const buttonStyle = {
            padding: '8px 12px',
            border: 'none',
            borderRadius: '0px',
            fontSize: '12px',
            fontWeight: 600,
            cursor: 'pointer',
            fontFamily,
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            textDecoration: 'none',
            boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.1)',
            position: 'relative',
            overflow: 'hidden',
            flex: '1',
            minWidth: '120px',
            maxWidth: '180px',
            justifyContent: 'center',
            height: '32px'
        };
        
        const approveBtn = {
            ...buttonStyle,
            background: `linear-gradient(135deg, ${successColor} 0%, #059669 100%)`,
            color: white,
            transform: 'translateY(0)',
            '&:hover': {
                transform: 'translateY(-2px)',
                boxShadow: '0 8px 25px 0 rgba(16, 185, 129, 0.4)'
            }
        };
        
        const rejectBtn = {
            ...buttonStyle,
            background: `linear-gradient(135deg, ${dangerColor} 0%, #dc2626 100%)`,
            color: white,
            transform: 'translateY(0)',
            '&:hover': {
                transform: 'translateY(-2px)',
                boxShadow: '0 8px 25px 0 rgba(239, 68, 68, 0.4)'
            }
        };
        
        const contentContainer = {
            padding: '0 20px 20px 20px',
            width: '100%',
            boxSizing: 'border-box',
            flex: 1,
            overflowY: 'auto',
            overflowX: 'hidden',
            '@media (max-width: 768px)': {
                padding: '0 16px 16px 16px'
            },
            '@media (max-width: 480px)': {
                padding: '0 12px 12px 12px'
            }
        };
        
        const tabContainer = {
            width: '100%',
            background: white,
            borderRadius: '16px',
            overflow: 'hidden',
            boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
            border: '1px solid #e2e8f0',
            marginBottom: '24px',
            position: 'relative',
            '&::before': {
                content: '""',
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                height: '4px',
                background: `linear-gradient(90deg, ${primaryColor} 0%, ${secondaryColor} 50%, ${successColor} 100%)`,
                borderRadius: '16px 16px 0 0'
            },
            '@media (max-width: 768px)': {
                borderRadius: '12px',
                marginBottom: '20px',
                boxShadow: '0 6px 20px -4px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)'
            }
        };

        const tabNavigation = {
            display: 'flex',
            background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 50%, #f1f5f9 100%)',
            borderBottom: '1px solid #e2e8f0',
            overflowX: 'auto',
            padding: '8px 8px 0 8px',
            position: 'relative',
            '&::after': {
                content: '""',
                position: 'absolute',
                bottom: 0,
                left: 0,
                right: 0,
                height: '1px',
                background: 'linear-gradient(90deg, transparent 0%, #e2e8f0 50%, transparent 100%)'
            },
            '@media (max-width: 768px)': {
                flexWrap: 'wrap',
                padding: '6px 6px 0 6px'
            }
        };

        const tabButton = {
            padding: '12px 16px',
            border: 'none',
            background: 'rgba(255, 255, 255, 0.9)',
            cursor: 'pointer',
            fontSize: '13px',
            fontWeight: 600,
            fontFamily,
            color: darkGray,
            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            minWidth: '100px',
            justifyContent: 'center',
            borderRadius: '12px 12px 0 0',
            position: 'relative',
            marginBottom: '-1px',
            transform: 'translateY(0)',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1), 0 2px 4px rgba(0, 0, 0, 0.06)',
            backdropFilter: 'blur(10px)',
            border: '1px solid rgba(255, 255, 255, 0.2)',
            '&:hover': {
                background: 'rgba(255, 255, 255, 0.95)',
                color: primaryColor,
                transform: 'translateY(-4px)',
                boxShadow: '0 8px 25px rgba(37, 99, 235, 0.2), 0 4px 12px rgba(0, 0, 0, 0.15)'
            },
            '&::before': {
                content: '""',
                position: 'absolute',
                bottom: 0,
                left: '50%',
                transform: 'translateX(-50%)',
                width: '0%',
                height: '3px',
                background: `linear-gradient(90deg, ${primaryColor} 0%, ${secondaryColor} 100%)`,
                borderRadius: '2px',
                transition: 'width 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
            },
            '@media (max-width: 768px)': {
                padding: '10px 14px',
                fontSize: '12px',
                minWidth: '80px',
                gap: '6px'
            },
            '@media (max-width: 480px)': {
                padding: '8px 12px',
                fontSize: '11px',
                minWidth: '70px',
                gap: '4px'
            }
        };

        const activeTabButton = {
            ...tabButton,
            color: 'white',
            background: 'linear-gradient(135deg, #395d9a 0%, #2d4a7a 100%)',
            fontWeight: 700,
            boxShadow: '0 6px 20px rgba(57, 93, 154, 0.4), 0 2px 8px rgba(0, 0, 0, 0.1)',
            transform: 'translateY(-2px)',
            backdropFilter: 'blur(15px)',
            border: '1px solid rgba(255, 255, 255, 0.3)',
            '&::before': {
                content: '""',
                position: 'absolute',
                bottom: 0,
                left: '50%',
                transform: 'translateX(-50%)',
                width: '80%',
                height: '3px',
                background: '#395d9a',
                borderRadius: '2px',
                transition: 'width 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
            },
            '&:hover': {
                background: 'linear-gradient(135deg, #2d4a7a 0%, #1e3a5f 100%)',
                color: 'white',
                transform: 'translateY(-6px)',
                boxShadow: '0 12px 30px rgba(57, 93, 154, 0.5), 0 4px 12px rgba(0, 0, 0, 0.2)'
            }
        };

        const tabContent = {
            padding: '20px',
            minHeight: '300px',
            background: 'linear-gradient(135deg, #ffffff 0%, #fafbfc 100%)',
            position: 'relative',
            '&::before': {
                content: '""',
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                height: '1px',
                background: 'linear-gradient(90deg, transparent 0%, #e2e8f0 50%, transparent 100%)'
            },
            '@media (max-width: 768px)': {
            padding: '16px',
                minHeight: '250px'
            },
            '@media (max-width: 480px)': {
                padding: '12px',
                minHeight: '200px'
            }
        };

        const tabSection = {
            display: 'flex',
            flexDirection: 'column',
            gap: '12px',
            animation: 'fadeIn 0.4s ease-in-out'
        };

        const infoItem = {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '12px 16px',
            background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
            borderRadius: '12px',
            border: '1px solid #e2e8f0',
            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            position: 'relative',
            overflow: 'hidden',
            '&::before': {
                content: '""',
                position: 'absolute',
                top: 0,
                left: 0,
                width: '4px',
                height: '100%',
                background: `linear-gradient(180deg, ${primaryColor} 0%, ${secondaryColor} 100%)`,
                borderRadius: '0 2px 2px 0'
            },
            '&:hover': {
                transform: 'translateY(-2px)',
                boxShadow: '0 8px 25px -5px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
                borderColor: '#cbd5e1'
            },
            '@media (max-width: 768px)': {
                flexDirection: 'column',
                alignItems: 'flex-start',
                gap: '8px',
                padding: '10px 12px'
            }
        };
        
        const infoLabel = {
            fontSize: '14px',
            fontWeight: 700,
            fontFamily,
            color: '#374151',
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            minWidth: '140px',
            letterSpacing: '0.025em',
            '@media (max-width: 768px)': {
                fontSize: '14px',
                minWidth: 'auto',
                gap: '10px'
            }
        };
        
        const infoValue = {
            fontSize: '14px',
            fontWeight: 500,
            fontFamily,
            color: '#1f2937',
            textAlign: 'right',
            flex: 1,
            wordBreak: 'break-word',
            lineHeight: '1.5',
            '@media (max-width: 768px)': {
                textAlign: 'left',
                fontSize: '14px'
            }
        };
        
        const listItem = {
            padding: '8px 0',
            fontSize: '13px',
            fontFamily,
            color: '#1e293b',
            borderBottom: '1px solid #f1f5f9',
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            transition: 'all 0.2s ease',
            borderRadius: '6px',
            margin: '0 -4px',
            paddingLeft: '4px',
            paddingRight: '4px',
            width: '100%',
            boxSizing: 'border-box',
            '&:last-child': {
                borderBottom: 'none'
            },
            '@media (max-width: 768px)': {
                padding: '10px 0',
                fontSize: '13px',
                gap: '10px'
            },
            '@media (max-width: 480px)': {
                padding: '8px 0',
                fontSize: '12px',
                gap: '8px'
            }
        };
        
        const listItemIcon = {
            width: '32px',
            height: '32px',
            borderRadius: '8px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '14px',
            color: white,
            fontWeight: 'bold',
            flexShrink: 0,
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',
            '@media (max-width: 768px)': {
                width: '28px',
                height: '28px',
                fontSize: '12px'
            },
            '@media (max-width: 480px)': {
                width: '24px',
                height: '24px',
                fontSize: '10px'
            }
        };
        
        const commentsSection = {
            background: white,
            borderRadius: '8px',
            overflow: 'hidden',
            boxShadow: '0 2px 4px -1px rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.06)',
            border: '1px solid #e2e8f0',
            marginTop: '12px',
            width: '100%'
        };
        
        const commentsTextarea = {
            width: '100%',
            minHeight: '140px',
            padding: '20px',
            border: '2px solid #e2e8f0',
            borderRadius: '12px',
            fontSize: '15px',
            fontFamily,
            resize: 'vertical',
            backgroundColor: (this.state.info.status === 'Rejected' || this.state.info.status === 'rejected') ? '#fef2f2' : 
                           (this.state.info.status === 'Approved' || this.state.info.status === 'approved') ? '#f0fdf4' : 
                           '#fafafa',
            transition: 'all 0.3s ease',
            outline: 'none',
            boxSizing: 'border-box',
            lineHeight: '1.6',
            '&:focus': {
                borderColor: primaryColor,
                boxShadow: `0 0 0 3px rgba(37, 99, 235, 0.1)`,
                backgroundColor: white
            },
            '@media (max-width: 768px)': {
                minHeight: '120px',
                padding: '16px',
                fontSize: '14px'
            },
            '@media (max-width: 480px)': {
                minHeight: '100px',
                padding: '12px',
                fontSize: '13px'
            }
        };
        
        const statusBadge = {
            padding: '8px 16px',
            borderRadius: '20px',
            fontSize: '13px',
            fontWeight: 700,
            fontFamily,
            textTransform: 'uppercase',
            letterSpacing: '0.5px',
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
            flexShrink: 0,
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
            '@media (max-width: 768px)': {
                padding: '6px 12px',
                fontSize: '12px',
                gap: '6px'
            },
            '@media (max-width: 480px)': {
                padding: '4px 8px',
                fontSize: '11px',
                gap: '4px'
            }
        };
        
        const emptyState = {
            textAlign: 'center',
            color: darkGray,
            fontSize: '16px',
            fontFamily,
            fontStyle: 'italic',
            padding: '32px 24px',
            background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)',
            borderRadius: '12px',
            border: '2px dashed #cbd5e1',
            width: '100%',
            boxSizing: 'border-box',
            position: 'relative',
            '&::before': {
                content: '""',
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: '60px',
                height: '60px',
                background: 'linear-gradient(135deg, rgba(37, 99, 235, 0.1) 0%, rgba(124, 58, 237, 0.05) 100%)',
                borderRadius: '50%',
                zIndex: 0
            },
            '@media (max-width: 768px)': {
                padding: '24px 20px',
                fontSize: '15px'
            },
            '@media (max-width: 480px)': {
                padding: '20px 16px',
                fontSize: '14px'
            }
        };
        
        const sectionTitle = {
            fontSize: '14px',
            fontWeight: 700,
            color: primaryColor,
            marginBottom: '12px',
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            width: '100%',
            boxSizing: 'border-box'
        };
        
        return (
            <div style={container}>
                <style>
                    {`
                        @keyframes spin {
                            0% { transform: rotate(0deg); }
                            100% { transform: rotate(360deg); }
                        }
                        
                        @keyframes fadeIn {
                            from {
                                opacity: 0;
                                transform: translateY(10px);
                            }
                            to {
                                opacity: 1;
                                transform: translateY(0);
                            }
                        }
                        
                        @keyframes slideIn {
                            from {
                                opacity: 0;
                                transform: translateX(-20px);
                            }
                            to {
                                opacity: 1;
                                transform: translateX(0);
                            }
                        }
                        
                        @keyframes pulse {
                            0%, 100% {
                                transform: scale(1);
                            }
                            50% {
                                transform: scale(1.05);
                            }
                        }
                        
                        .tab-content-enter {
                            animation: fadeIn 0.4s ease-in-out;
                        }
                        
                        .info-item-hover:hover {
                            animation: pulse 0.6s ease-in-out;
                        }
                    `}
                </style>
                <div style={header}>
                    <div style={headerTitle}>
                        <div style={headerIcon}>
                            <span className={'fa fa-project-diagram'}/>
                        </div>
                        <div style={{flex: 1, minWidth: 0}}>
                            <div style={{fontSize: '16px', fontWeight: 700, wordBreak: 'break-word'}}>
                                {this.state.info.name || 'Project Information'}
                            </div>
                            <div style={{fontSize: '11px', fontWeight: 400, color: darkGray, marginTop: '2px'}}>
                                Project Details & Management
                            </div>
                        </div>
                    </div>
                </div>
                
                {/* Loading/State Change Indicator */}
                {(sessionStorage.getItem('user_groups') === 'SUPERVISOR' || sessionStorage.getItem('user_groups') === 'ADMIN') &&
                 (this.state.isLoading || this.state.isRefreshing || this.state.isStateChanging) && (
                    <div style={{
                        ...actionButtons,
                        justifyContent: 'center',
                        padding: '20px',
                        background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)',
                        borderRadius: '12px',
                        border: '2px dashed #cbd5e1',
                        margin: '0 20px 20px 20px'
                    }}>
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '12px',
                            color: darkGray,
                            fontSize: '14px',
                            fontWeight: 500
                        }}>
                            <div style={{
                                width: '20px',
                                height: '20px',
                                border: '2px solid #e2e8f0',
                                borderTop: '2px solid ' + primaryColor,
                                borderRadius: '50%',
                                animation: 'spin 1s linear infinite'
                            }}></div>
                            {this.state.isLoading && 'Loading project information...'}
                            {this.state.isRefreshing && 'Refreshing data...'}
                            {this.state.isStateChanging && 'Processing changes...'}
                        </div>
                    </div>
                )}

                {/* Action Buttons - Hide if user clicked or if status is already approved */}
                {(sessionStorage.getItem('user_groups') === 'SUPERVISOR' || sessionStorage.getItem('user_groups') === 'ADMIN') &&
                 this.state.info.status !== 'Rejected' && this.state.info.status !== 'rejected' &&
                 this.state.info.status !== 'Approved' && this.state.info.status !== 'approved' &&
                 !this.state.userClickedApprove &&
                 this.state.buttonsVisible && !this.state.isLoading && !this.state.isRefreshing && !this.state.isStateChanging && (
                    <div style={actionButtons}>
                        <button onClick={() => this.approveProject('approved')} style={approveBtn}>
                            <span className={'fa fa-check-circle'}/>Approve Project
                        </button>
                        <button onClick={() =>
                            PopDetail.showDynamic('Project Rejection', 
                                <div style={{textAlign:'center',padding:'24px', background: white, borderRadius: '16px', fontFamily}}>
                                    <div style={{fontSize: '20px', marginBottom: '16px', color: primaryColor, fontWeight: 600, fontFamily}}>
                                        <span className={'fa fa-exclamation-triangle'} style={{marginRight: '8px'}}/>
                                        Project Rejection
                                    </div>
                                    <p style={{color: darkGray, marginBottom: '20px', fontFamily}}>Please provide a detailed reason for rejecting this project:</p>
                                    <textarea 
                                        name={'reason'} 
                                        style={{
                                            width: '100%', 
                                            padding: '16px',
                                            minHeight: '120px',
                                            fontSize: '14px',
                                            lineHeight: '1.5',
                                            resize: 'vertical',
                                            fontFamily: 'inherit',
                                            border: '2px solid #e2e8f0',
                                            borderRadius: '12px',
                                            outline: 'none',
                                            background: '#f8fafc'
                                        }} 
                                        placeholder="Enter detailed rejection reason..."
                                    />
                                    <div style={{marginTop: '24px', display: 'flex', gap: '12px', justifyContent: 'center'}}>
                                        <button onClick={() => {
                                            const reason = document.querySelector('textarea[name="reason"]').value;
                                            if (reason.trim()) {
                                                this.rejectProject('rejected', reason);
                                            } else {
                                                alert('Please provide a reason for rejection');
                                            }
                                        }} style={{
                                            ...buttonStyle,
                                            background: `linear-gradient(135deg, ${dangerColor} 0%, #dc2626 100%)`,
                                            color: 'white',
                                            borderRadius: '0px',
                                            height: '32px'
                                        }}>Submit Rejection</button>
                                        <button onClick={() => PopDetail.dismiss()} style={{
                                            ...buttonStyle,
                                            background: '#6b7280',
                                            color: 'white',
                                            borderRadius: '0px',
                                            height: '32px'
                                        }}>Cancel</button>
                                    </div>
                                </div>, 
                                50,
                                50
                            )
                        } style={rejectBtn}>
                            <span className={'fa fa-times-circle'}/>Reject Project
                        </button>
                    </div>
                )}

                <div style={contentContainer}>
                    {/* Tab Container */}
                    <div style={tabContainer}>
                        {/* Tab Navigation */}
                        <div style={tabNavigation}>
                            <button 
                                style={this.state.activeTab === 'overview' ? activeTabButton : tabButton}
                                onClick={() => this.setActiveTab('overview')}
                            >
                                <span className={'fa fa-info-circle'}/>
                                Overview
                            </button>
                            <button 
                                style={this.state.activeTab === 'timeline' ? activeTabButton : tabButton}
                                onClick={() => this.setActiveTab('timeline')}
                            >
                                <span className={'fa fa-calendar-alt'}/>
                                Timeline
                            </button>
                            <button 
                                style={this.state.activeTab === 'localities' ? activeTabButton : tabButton}
                                onClick={() => this.setActiveTab('localities')}
                            >
                                <span className={'fa fa-map-marked-alt'}/>
                                Localities
                            </button>
                            <button 
                                style={this.state.activeTab === 'funders' ? activeTabButton : tabButton}
                                onClick={() => this.setActiveTab('funders')}
                            >
                                <span className={'fa fa-building'}/>
                                Funders
                            </button>
                            <button 
                                style={this.state.activeTab === 'comments' ? activeTabButton : tabButton}
                                onClick={() => this.setActiveTab('comments')}
                            >
                                <span className={'fa fa-comment-dots'}/>
                                Comments
                            </button>
                        </div>

                        {/* Tab Content */}
                        <div style={tabContent}>
                            {/* Overview Tab */}
                            {this.state.activeTab === 'overview' && (
                                <div style={tabSection} className="tab-content-enter">
                                    <div style={infoItem} className="info-item-hover">
                                        <div style={infoLabel}>
                                            <span className={'fa fa-tag'} style={{color: primaryColor}}/>
                                Project Type
                                        </div>
                                        <div style={infoValue}>{this.state.info.type || 'Not specified'}</div>
                        </div>
                                    <div style={infoItem} className="info-item-hover">
                                        <div style={infoLabel}>
                                            <span className={'fa fa-briefcase'} style={{color: primaryColor}}/>
                                Project Name
                                        </div>
                                        <div style={infoValue}>{this.state.info.name || 'Not specified'}</div>
                        </div>
                                    <div style={infoItem} className="info-item-hover">
                                        <div style={infoLabel}>
                                            <span className={'fa fa-info-circle'} style={{color: primaryColor}}/>
                                Description
                                        </div>
                                        <div style={infoValue}>{this.state.info.description || 'No description available'}</div>
                        </div>
                                    <div style={infoItem} className="info-item-hover">
                                        <div style={infoLabel}>
                                            <span className={'fa fa-dollar-sign'} style={{color: primaryColor}}/>
                                Budget
                                        </div>
                                        <div style={infoValue}>{this.state.info.budget || 'Not specified'}</div>
                                    </div>
                                    <div style={infoItem} className="info-item-hover">
                                        <div style={infoLabel}>
                                            <span className={'fa fa-flag'} style={{color: primaryColor}}/>
                                            Status
                                        </div>
                                        <div style={infoValue}>
                                            <span style={{
                                                ...statusBadge,
                                                backgroundColor: (this.state.info.status === 'Approved' || this.state.info.status === 'approved') ? '#dcfce7' : 
                                                               (this.state.info.status === 'Rejected' || this.state.info.status === 'rejected') ? '#fef2f2' : '#fef3c7',
                                                color: (this.state.info.status === 'Approved' || this.state.info.status === 'approved') ? '#166534' : 
                                                       (this.state.info.status === 'Rejected' || this.state.info.status === 'rejected') ? '#991b1b' : '#92400e',
                                                border: (this.state.info.status === 'Approved' || this.state.info.status === 'approved') ? '1px solid #bbf7d0' : 
                                                       (this.state.info.status === 'Rejected' || this.state.info.status === 'rejected') ? '1px solid #fecaca' : '1px solid #fde68a'
                                            }}>
                                                <span className={(this.state.info.status === 'Approved' || this.state.info.status === 'approved') ? 'fa fa-check-circle' : 
                                                               (this.state.info.status === 'Rejected' || this.state.info.status === 'rejected') ? 'fa fa-times-circle' : 'fa fa-clock'}/>
                                                {this.state.info.status || 'Pending'}
                            </span>
                                        </div>
                        </div>
                    </div>
                            )}

                            {/* Timeline Tab */}
                            {this.state.activeTab === 'timeline' && (
                                <div style={tabSection}>
                                    <div style={infoItem}>
                                        <div style={infoLabel}>
                                            <span className={'fa fa-calendar-plus'} style={{color: primaryColor}}/>
                                            Registration Date
                        </div>
                                        <div style={infoValue}>{this.state.info.reg_date || 'Not specified'}</div>
                        </div>
                                    <div style={infoItem}>
                                        <div style={infoLabel}>
                                            <span className={'fa fa-calendar-check'} style={{color: primaryColor}}/>
                                Authorization Date
                                        </div>
                                        <div style={infoValue}>{this.state.info.auth_date || 'Not specified'}</div>
                                    </div>
                                    <div style={infoItem}>
                                        <div style={infoLabel}>
                                            <span className={'fa fa-clock'} style={{color: primaryColor}}/>
                                            Last Updated
                        </div>
                                        <div style={infoValue}>{this.state.info.updated_at || 'Not specified'}</div>
                        </div>
                    </div>
                            )}

                            {/* Localities Tab */}
                            {this.state.activeTab === 'localities' && (
                                <div style={tabSection}>
                        {this.state.info.localities && this.state.info.localities.length > 0 ? (
                            this.state.info.localities.map((locality, i) => (
                                            <div key={i} style={infoItem}>
                                                <div style={infoLabel}>
                                                    <div style={{
                                                        ...listItemIcon,
                                                        background: `linear-gradient(135deg, ${successColor} 0%, #059669 100%)`
                                                    }}>
                                                        <span className={'fa fa-map-pin'}/>
                                                    </div>
                                                    Locality {i + 1}
                                                </div>
                                                <div style={infoValue}>
                                                    <span style={{fontWeight: 500}}>{locality.name}</span>
                                                </div>
                                </div>
                            ))
                        ) : (
                            <div style={emptyState}>
                                            <span className={'fa fa-map-marked-alt'} style={{fontSize: '24px', marginBottom: '8px', display: 'block'}}/>
                                No localities assigned
                            </div>
                        )}
                    </div>
                            )}

                            {/* Funders Tab */}
                            {this.state.activeTab === 'funders' && (
                                <div style={tabSection}>
                        {this.state.info.funders && this.state.info.funders.length > 0 ? (
                            this.state.info.funders.map((funder, i) => (
                                            <div key={i} style={infoItem}>
                                                <div style={infoLabel}>
                                                    <div style={{
                                                        ...listItemIcon,
                                                        background: `linear-gradient(135deg, ${secondaryColor} 0%, #6d28d9 100%)`
                                                    }}>
                                                        <span className={'fa fa-building'}/>
                                                    </div>
                                                    Funder {i + 1}
                                                </div>
                                                <div style={infoValue}>
                                                    <span style={{fontWeight: 500}}>{funder.name}</span>
                                                </div>
                                </div>
                            ))
                        ) : (
                            <div style={emptyState}>
                                            <span className={'fa fa-building'} style={{fontSize: '24px', marginBottom: '8px', display: 'block'}}/>
                                No funders assigned
                            </div>
                        )}
                    </div>
                            )}

                            {/* Comments Tab */}
                            {this.state.activeTab === 'comments' && (
                                <div style={tabSection}>
                                    <div style={infoItem}>
                                        <div style={infoLabel}>
                                            <span className={'fa fa-comment-dots'} style={{color: primaryColor}}/>
                                            NLUPC Comments & Feedback
                    </div>
                                        <div style={{width: '100%', marginTop: '12px'}}>
                            <textarea 
                        style={commentsTextarea}
                                readOnly={true} 
                                defaultValue={this.state.info.remarks}
                        placeholder="No comments available..."
                            />
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}